// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VISHAL BHARATHI
// Last ADD : ENACH REPORT EXPORT SERVICE REMOVED
// MODIFIED DATE: 19-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH ENACH REPORT START *********************** */
export const fetchENACHReport = (fetchData: any) => {
	const data = {
		FetchEnachReportListToken: fetchData,
	};
	const url = `${API_URL}getENACHReportList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ENACH REPORT END *********************** */
